'use client'

import * as React from 'react'

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@ui/web/components'
import { getStaticAssetUrl } from '@helper/utils/file'

interface AreYouSureDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /**
   * The title of the dialog (optional).
   * Default to "Batalkan aksi?"
   */
  title?: string
  /**
   * The description of the dialog (optional).
   * Default to "Kamu akan membatalkan aksi ini."
   */
  description?: string
  /**
   * Function to be called when the user confirms the action.
   * May be sync or async (returns void or Promise<void>).
   */
  onConfirm: () => void | Promise<void>
}

export function AreYouSureDialog({
  open,
  onOpenChange,
  title = 'Batalkan aksi?',
  description = 'Kamu akan membatalkan aksi ini.',
  onConfirm,
}: AreYouSureDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='srd:max-w-sm srd:border srd:border-main-red-100' showCloseButton={false}>
        <div className='srd:flex srd:w-full srd:flex-col srd:items-center srd:justify-center srd:gap-y-8 srd:text-center'>
          <img
            src={getStaticAssetUrl('illustration/foam.png')}
            alt=''
            width={70}
            height={70}
            draggable={false}
            className='srd:block'
          />

          <DialogHeader className='srd:flex srd:flex-col srd:items-center srd:gap-2 srd:text-center'>
            <DialogTitle className='srd:text-lg srd:font-bold'>{title}</DialogTitle>
            <DialogDescription className='srd:sr-only'>{description}</DialogDescription>
          </DialogHeader>

          <p className='srd:text-sm'>{description}</p>

          <div className='srd:flex srd:w-full srd:flex-col srd:items-center srd:justify-center srd:gap-y-2'>
            <Button variant='destructive' onClick={onConfirm} className='srd:w-full srd:flex-1'>
              Ya, batalkan
            </Button>

            <DialogClose
              render={
                <Button variant='link' className='srd:w-full srd:flex-1'>
                  Tidak
                </Button>
              }
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
